import React, { forwardRef } from "react";
import { Row } from "react-aria-components";
import clsx from "clsx";

import styles from "./table-row.module.css";

interface TableRowProps {
  link?: { href: string; target?: string };
  style?: React.CSSProperties;
  children: React.ReactNode;
  type?: "summary" | "standard";
  "data-testid"?: string;
  "data-test-role"?: string;
  className?: string;
  onAction?: () => void;
  onHoverStart?: () => void;
  onHoverEnd?: () => void;
}

const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  function TableRow(
    {
      children,
      "data-testid": testId,
      "data-test-role": testRole,
      link,
      type = "standard",
      style,
      className,
      onHoverStart,
      onHoverEnd,
      onAction,
    },
    ref,
  ) {
    return (
      <Row
        ref={ref}
        style={style}
        className={clsx(
          {
            [styles.hoverable]: link || onAction,
            [styles.summaryRow]: type === "summary",
          },
          className,
        )}
        onAction={onAction}
        href={link?.href}
        onHoverStart={onHoverStart}
        onHoverEnd={onHoverEnd}
        data-testid={testId}
        data-test-role={testRole}
      >
        {children}
      </Row>
    );
  },
);

export default TableRow;
